import "../askgvt.css";
import { render } from "solid-js/web";
import { DiscoveryApp } from "./DiscoveryApp";

const mount = () => {
	render(() => <DiscoveryApp />, document.body);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", mount);
} else {
	mount();
}
